/**
 * HIS 嵌入伴随小窗（Tauri 轻壳）激活判断。
 *
 * 该文件放在 shared 层，供 router、layout store、登录页和窗口控制 composable 共用。
 */

export function isEmbedUrlActivation(): boolean {
  if (typeof window === "undefined") return false;
  const params = new URLSearchParams(window.location.search);
  return params.get("embed") === "1" || params.get("mode") === "embed";
}

export function isTauriShellRuntime(): boolean {
  if (typeof window === "undefined") return false;
  const w = window as Window & {
    __TAURI__?: unknown;
    __TAURI_INTERNALS__?: unknown;
  };
  return Boolean(w.__TAURI__ || w.__TAURI_INTERNALS__);
}

export function shouldActivateEmbedShell(): boolean {
  return isEmbedUrlActivation() || isTauriShellRuntime();
}

export function medicalHomeRoute(): {
  path: string;
  query?: Record<string, string>;
} {
  return shouldActivateEmbedShell()
    ? { path: "/medical", query: { embed: "1" } }
    : { path: "/medical" };
}
